/**
 * Module Colors - Uses the global theme system
 * 
 * This file provides backward compatibility with existing components
 * while transitioning to the new theme system.
 */

// Module color definitions matching the global theme
export const MODULE_COLORS = {
  'medical': {
    name: 'Medical',
    path: '/medical',
    color: '#86EFAC',        // Pastel mint
    light: '#DCFCE7',
    lighter: '#F0FDF4',
    dark: '#166534',
    icon: '#22C55E',
  },
  'dates': {
    name: 'Important Dates',
    path: '/dates',
    color: '#7DD3FC',        // Pastel sky blue
    light: '#E0F2FE',
    lighter: '#F0F9FF',
    dark: '#0369A1',
    icon: '#0EA5E9',
  },
  'parking': {
    name: 'Parking',
    path: '/parking',
    color: '#C4B5FD',        // Pastel lavender
    light: '#EDE9FE',        // Light tint
    lighter: '#F5F3FF',      // Very light
    dark: '#5B21B6',         // Dark text/icons
    icon: '#8B5CF6',         // Icon color
    surface: '#FAFAFD',      // Card surface
    border: '#DDD6FE',       // Border
    hover: '#EDE9FE',        // Hover
    activeTab: '#E9E5FD',    // Active tab
  },
  'car-maintenance': {
    name: 'Vehicles',
    path: '/car-maintenance',
    color: '#BFE3E0',        // Pastel teal - primary
    light: '#D5EFEC',        // Light tint
    lighter: '#EAF7F6',      // Very light / background
    dark: '#1F5F5B',         // Dark text/icons
    icon: '#8ECFC9',         // Icon/accent color
    surface: '#F5FAFA',      // Card surface
    border: '#B5DDD9',       // Border
    hover: '#D5EFEC',        // Hover
    activeTab: '#D5EFEC',    // Active tab
    good: '#22C55E',         // Status: Good
    dueSoon: '#F59E0B',      // Status: Due Soon
    overdue: '#EF4444',      // Status: Overdue/Action Needed
  },
  'documents': {
    name: 'Documents',
    path: '/documents',
    color: '#A8A5A1',        // Cool grey accent
    light: '#F0EFED',        // Light tint
    lighter: '#F8F7F6',      // Very light
    dark: '#4A4745',         // Dark text/icons
    icon: '#6B6966',         // Icon color
    surface: '#FAFAF9',      // Card surface
    border: '#E5E4E2',       // Border
    hover: '#EBEAE8',        // Hover
    activeTab: '#E8E7E5',    // Active tab
  },
  'shopping': {
    name: 'Shopping',
    path: '/shopping',
    color: '#86EFAC',        // Pastel green - fresh
    light: '#DCFCE7',        // Light tint
    lighter: '#F0FDF4',      // Very light
    dark: '#166534',         // Dark text/icons
    icon: '#22C55E',         // Icon color
    surface: '#FAFDF7',      // Card surface
    border: '#D1FAE5',       // Border
    hover: '#ECFDF5',        // Hover
    activeTab: '#DCFCE7',    // Active tab
    progressBar: '#4ADE80', // Progress bar fill
    progressBg: '#D1FAE5',  // Progress bar background
  },
  'contacts-places': {
    name: 'Contacts & Places',
    path: '/contacts-places',
    color: '#F9A8D4',        // Pastel pink - warm
    light: '#FCE7F3',        // Light tint
    lighter: '#FDF2F8',      // Very light
    dark: '#9D174D',         // Dark text/icons
    icon: '#EC4899',         // Icon color
    surface: '#FEFCFE',      // Card surface
    border: '#FBCFE8',       // Border
    hover: '#FCE7F3',        // Hover
    activeTab: '#FCE7F3',    // Active tab
  },
};

/**
 * Get module color configuration by key
 */
export const getModuleColor = (moduleKey) => {
  return MODULE_COLORS[moduleKey] || MODULE_COLORS['documents'];
};

/**
 * Get module name by key
 */
export const getModuleName = (moduleKey) => {
  return MODULE_COLORS[moduleKey]?.name || 'Unknown';
};

/**
 * Get module path by key
 */
export const getModulePath = (moduleKey) => {
  return MODULE_COLORS[moduleKey]?.path || '/';
};

/**
 * Get all module keys
 */
export const getModuleKeys = () => {
  return Object.keys(MODULE_COLORS);
};

export default MODULE_COLORS;
